export const getUniqueVariants = ({ variantKey = '', variants = [] }) => {
    if (!variantKey || !variantKey.trim()) return []

    const optionList = {
        [variantKey]: [],
    }
    const filteredItemsList = []
    let optionValue

    //Find all items that matches my variantKey
    //ex: "color"
    //Make an array of each variant
    for (let item of variants) {
        switch (typeof item[variantKey]) {
            case 'object':
                optionValue = item[variantKey].label
                break
            default:
                optionValue = item[variantKey]
        }
        //Make sure we add any non null values we dont already know about
        if (optionValue && optionList[variantKey].indexOf(optionValue) < 0) {
            optionList[variantKey].push(optionValue)
            filteredItemsList.push(item[variantKey])
        }
    }

    return filteredItemsList
}

//Recalculate the current total cost of the item
export const calculateItemCost = ({
    currentData,
    currentShippingMethod,
    itemUnitCost,
    itemQuantity,
    itemTax,
    itemShippingCost,
}) => {
    let newItemCost = currentData
    //Get cost per unit
    if (typeof itemUnitCost !== 'undefined') {
        newItemCost = newItemCost.set('itemUnitCost', parseFloat(itemUnitCost).toFixed(2))
    }
    //Get quantity
    if (typeof itemQuantity !== 'undefined') {
        newItemCost = newItemCost.set('itemQuantity', parseInt(itemQuantity))
    }
    //Get Tax
    if (typeof itemTax !== 'undefined') {
        newItemCost = newItemCost.set('itemTax', parseFloat(itemTax))
    }
    //Get Shipping Cost
    if (typeof currentShippingMethod !== 'undefined') {
        newItemCost = newItemCost.set('currentShippingMethod', currentShippingMethod)
    }
    if (typeof itemShippingCost !== 'undefined') {
        newItemCost = newItemCost.set('itemShippingCost', parseFloat(itemShippingCost))
    }
    //Update Purchase cost
    let totalCost = newItemCost.get('itemUnitCost') * newItemCost.get('itemQuantity')
    totalCost += newItemCost.get('itemTax')
    totalCost += newItemCost.get('itemShippingCost')
    totalCost = Math.round(totalCost * 100) / 100
    newItemCost = newItemCost.set('itemPurchaseCost', totalCost)

    return newItemCost
}

export const getVariantAttributes = ({ item }) => {
    const { keys: attributesKeys } = item.attributes
    const { variants } = item

    const variantTypes = attributesKeys.reduce((acc, cur) => ({ [cur]: {}, ...acc }), {})

    const attributeValues = variants.reduce((acc, cur) => {
        Object.keys(variantTypes).forEach(option => {
            const label = cur[option].label
            acc[option][label] = { ...cur[option] }
        })

        return acc
    }, variantTypes)

    return {
        attributesKeys,
        attributeValues,
    }
}

export const getDisabledVariants = ({ selectedVariants, variantList }) => {
    const variantKeys = Object.keys(selectedVariants)

    let disabledVariants = {}

    Object.keys(selectedVariants).forEach((option, index) => {
        disabledVariants[option] = variantList
            .filter(
                variant =>
                    variant[variantKeys[index]].label == selectedVariants[variantKeys[index]] && !variant.is_enabled
            )
            .map(variant => variant.label)
    })

    return disabledVariants
}

//TODO: make this better, should probably break this up
export const buildHotspotsPaymentCatalog = ({ hotspots, paymentData = [] }) => {
    let paymentHotspots = {}

    let catalog =
        paymentData.reduce((catalog, item) => {
            return Object.assign({}, catalog, {
                [`prodId_${item.payments_product_id}`]: Object.assign({}, { attributes: ['color', 'size'] }, item),
            })
        }, {}) || {}

    //check if there's paymentData, if there is run the for loop
    if (paymentData.length > 0) {
        for (let paymentItem of paymentData) {
            for (let mainMediaId in hotspots) {
                if (hotspots[mainMediaId]) {
                    for (let hotspotIndex in hotspots[mainMediaId]) {
                        //if the payment productid matches with the hotspot payment id
                        if (
                            paymentItem.payments_product_id == hotspots[mainMediaId][hotspotIndex].payments_product_id
                        ) {
                            const hotspotItem = hotspots[mainMediaId][hotspotIndex]

                            const uniqueColorVariants = getUniqueVariants({
                                variantKey: 'color',
                                variants: paymentItem.variants,
                            })

                            const hotspot = {
                                [hotspotIndex]: {
                                    ...hotspotItem,
                                    ...paymentItem,
                                    colors: uniqueColorVariants,
                                },
                            }

                            // merge the object together
                            paymentHotspots[mainMediaId] = {
                                ...hotspots[mainMediaId],
                                ...paymentHotspots[mainMediaId],
                                ...hotspot,
                            }

                            let currentCatalogItem = catalog[`prodId_${paymentItem.payments_product_id}`]

                            catalog[`prodId_${paymentItem.payments_product_id}`] = {
                                ...currentCatalogItem,
                                imageUrl: hotspotItem.media_items[0].external_url,
                            }
                        }
                    }
                }
            }
        }
    }

    return { hotspots: paymentHotspots, catalog }
}

/**
 * Assures that each field has non empty ("") values.
 * @param {*} state
 * @param {*} form
 */
export const hasRequiredFields = (state, form) => {
    const requiredFields = state.getIn([form, 'requiredFields'])
    const values = state.getIn([form, 'values'])

    return requiredFields.every(field => values.get(field) != '')
}

/**
 * Assures that each field has valid values. The state validationField object has
 * two properties - id and validation. ID referes to the field name and validation is a predicate
 * function to determine if the value is valid or not.
 * @param {*} state
 * @param {*} form
 */
export const hasValidFields = (state, form) => {
    const validationFields = state.getIn([form, 'validationFields'])
    const values = state.getIn([form, 'values'])

    return validationFields.every(field => {
        const fieldValue = values.get(field.id)

        return field.validation(fieldValue)
    })
}

export const formatCreditCardsMap = ({ creditCards }) => {
    let creditCardsMap = {}
    for (let [cardId, card] of Object.entries(creditCards)) {
        if (!creditCardsMap[card.fingerprint]) {
            creditCardsMap[card.fingerprint] = {
                brand: card.brand,
                lastFour: card.last4,
            }
        }
    }
    return creditCardsMap
}

const timeDifference = (date1, date2) => {
    let difference = date1.getTime() - date2.getTime()

    const days = Math.floor(difference / 1000 / 60 / 60 / 24)

    difference -= days * 1000 * 60 * 60 * 24

    const hours = Math.floor(difference / 1000 / 60 / 60)

    difference -= hours * 1000 * 60 * 60

    const minutes = Math.floor(difference / 1000 / 60)

    difference -= minutes * 1000 * 60

    const seconds = Math.floor(difference / 1000)

    return {
        days,
        hours,
        minutes,
        seconds,
    }
}

const pluralize = (str, exp = true) => {
    return exp ? str + 's' : str
}

export const timeDifferenceString = (date1, date2) => {
    const { days, hours, minutes } = timeDifference(date1, date2)

    if (days == 0 && hours == 0 && minutes == 0) return 'less than a min ago'
    else if (days == 0 && hours == 0) return `${minutes} ${pluralize('min', minutes > 1)} ago`
    else if (days == 0) return `${hours} ${pluralize('hr', hours > 1)} ago`
    else return `${days} ${pluralize('day', days > 1)} ago`
}
